import sashaPic from "@/public/images/artists/sasha.png";
import { Artist } from "@/types/types";

export const sasha = {
  id: "4",
  name: "Sasha",
  image: sashaPic,
  description: `Sasha exudes a captivating attitude in her singing style. This makes her a versatile fit for an array of genres including EDM, Pop, and R&B, among others.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsasha-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance"],
      secondary: ["Singer", "Techno", "Disco"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
